<template>
  <div class="number-icon">{{value}}</div>
</template>

<script>
  export default {
    name: 'number-icon',
    props: ['value']
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .number-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: $notif;
    color: $body-light;
    line-height: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// NumberIcon.vue?d55eaf22